import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { FiltersBar, FilterField, CategorySelector } from '../base';
import { FolderTree } from 'lucide-react';

interface ProductsFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  selectedCategoryId: string | undefined;
  onCategoryChange: (categoryId: string | undefined) => void;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}

const ProductsFilters: React.FC<ProductsFiltersProps> = ({
  searchQuery,
  onSearchChange,
  selectedCategoryId,
  onCategoryChange,
  hasActiveFilters,
  onClearFilters,
}) => {
  const { t } = useTranslation('products');

  return (
    <FiltersBar
      title={t('filters.title')}
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      searchPlaceholder={t('filters.searchPlaceholder')}
      hasActiveFilters={hasActiveFilters}
      onClearFilters={onClearFilters}
      clearFiltersLabel={t('filters.clearAll')}
      gridCols="2"
    >
      <FilterField label={t('filters.category')} icon={FolderTree}>
        <CategorySelector
          value={selectedCategoryId || 'all'}
          onChange={(value) => onCategoryChange(value === 'all' ? undefined : (value as string))}
          placeholder={t('filters.allCategories')}
          variant="bordered"
          label=""
          showAllOption={true}
          className="w-full"
        />
      </FilterField>
    </FiltersBar>
  );
};

export default ProductsFilters;
